
export function calculateMidDate(startDateStr, deadlineDateStr) {
  const startDate = new Date(startDateStr);
  const deadlineDate = new Date(deadlineDateStr);


  function isWorkingDay(date) {
    const day = date.getDay();
    return day !== 0 && day !== 6; // 0 = Sunday, 6 = Saturday
  }

  let totalWorkingDays = 0;
  let tempDate = new Date(startDate);
  while (tempDate < deadlineDate) {
    tempDate.setDate(tempDate.getDate() + 1);
    if (isWorkingDay(tempDate)) {
      totalWorkingDays++;
    }
  }

  // Midpoint in working days
  const halfDays = Math.floor(totalWorkingDays / 2);

  // Helper to add working days to a date
  function addWorkingDays(date, daysToAdd) {
    let current = new Date(date);
    let added = 0;
    while (added < daysToAdd) {
      current.setDate(current.getDate() + 1);
      if (isWorkingDay(current)) {
        added++;
      }
    }
    return current;
  }

  const midDate = addWorkingDays(startDate, halfDays);
  return midDate.toISOString().split("T")[0]; // returns YYYY-MM-DD
}
